// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__3prNW","content":"styles_content__2_ib6","checkbox":"styles_checkbox__z8rfH","checkboxLabel":"styles_checkboxLabel__2q6b8"};